import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CurrencyContext = createContext(null);
export const useCurrency = () => useContext(CurrencyContext);

const detectDefault = () => {
  const saved = localStorage.getItem("jero_currency");
  if (saved === "USD" || saved === "UGX") return saved;
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const lang = (navigator.language || "").toUpperCase();
    if (tz.startsWith("Africa/") || lang.endsWith("-UG")) return "UGX";
  } catch (e) {
    console.error("Currency auto-detection failed:", e);
  }
  return "USD";
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(detectDefault);
  const [rate, setRate] = useState(3800);

  useEffect(() => {
    api.get("/config").then(({ data }) => { if (data.usd_to_ugx) setRate(data.usd_to_ugx); }).catch(() => {});
  }, []);

  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem("jero_currency", c);
  };

  const format = (usd) => {
    if (currency === "UGX") {
      return `USh ${Math.round(usd * rate).toLocaleString()}`;
    }
    return `$${Number(usd).toFixed(2)}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, rate, format }}>
      {children}
    </CurrencyContext.Provider>
  );
};
